import React, { useEffect, useState, useRef } from 'react';
import styles from './TasksPage.module.css';
import TasksHeader from './TasksHeader/TasksHeader';
import DailyTasks from './DailyTasks/DailyTasks';
import BalanceTop from '../../components/BalanceTop/BalanceTop';
import PartnerTasks from './PartnerTasks/PartnerTasks';
import { TaskModal } from './PartnerTasks/TasksModal';
import Loader from '../../components/Loader/Loader';
import type { WebApp } from '../../types/telegram';
// import LeadCard from './LeadCard';

interface ExtendedWebApp extends WebApp {
  contentSafeAreaInset?: {
    top: number;
    bottom: number;
    left: number;
    right: number;
  };
}

const TasksPage = () => {
  const [isBackgroundLoaded, setIsBackgroundLoaded] = useState(false);
  const [isDailyTasksLoaded, setIsDailyTasksLoaded] = useState(false);
  const [isPartnerTasksLoaded, setIsPartnerTasksLoaded] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  // Проверяем загрузку всех компонентов
  const isAllLoaded =
    isBackgroundLoaded && isDailyTasksLoaded && isPartnerTasksLoaded;

  // Создаем стабильные callback'и
  const handleDailyTasksLoadingChange = React.useCallback(
    (isLoading: boolean) => {
      setIsDailyTasksLoaded(!isLoading);
    },
    [],
  );

  const handlePartnerTasksLoadingChange = React.useCallback(
    (isLoading: boolean) => {
      setIsPartnerTasksLoaded(!isLoading);
    },
    [],
  );

  useEffect(() => {
    const tg = window.Telegram?.WebApp as ExtendedWebApp;
    if (!tg) return;

    const apply = () => {
      const top = tg?.contentSafeAreaInset?.top ?? 0;
      document.documentElement.style.setProperty(
        '--tg-viewport-content-safe-area-inset-top',
        `${top}px`,
      );
    };

    apply();
    tg.onEvent?.('contentSafeAreaChanged', apply);
    return () => tg.offEvent?.('contentSafeAreaChanged', apply);
  }, []);

  // Загружаем фоновое изображение
  useEffect(() => {
    console.log('Начинаем загрузку фонового изображения');

    // Создаем изображение с прямым путем к файлу
    const img = new Image();

    img.onload = () => {
      console.log('Фоновое изображение загружено успешно');
      setIsBackgroundLoaded(true);
    };

    img.onerror = () => {
      console.log('Ошибка загрузки фонового изображения, продолжаем без него');
      setIsBackgroundLoaded(true);
    };

    // Пробуем разные пути к изображению
    const imagePaths = [
      '/src/assets/backgrounds/TasksPageBackground.webp',
      './src/assets/backgrounds/TasksPageBackground.webp',
      'src/assets/backgrounds/TasksPageBackground.webp',
    ];

    // Пробуем первый путь
    img.src = imagePaths[0];

    // Если не загрузилось за 3 секунды, считаем загруженным
    const timeout = setTimeout(() => {
      console.log('Таймаут загрузки фонового изображения');
      setIsBackgroundLoaded(true);
    }, 10000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  console.log('Состояния загрузки:', {
    isBackgroundLoaded,
    isDailyTasksLoaded,
    isPartnerTasksLoaded,
    isAllLoaded,
  });

  return (
    <div
      ref={containerRef}
      className={`${styles.container} ${
        !isAllLoaded ? styles.container_loading : ''
      }`}
    >
      <TaskModal />

      {/* Loader показывается поверх контента */}
      {!isAllLoaded && (
        <div className={styles.container__loaderContainer}>
          <Loader />
        </div>
      )}

      {/* Контент всегда рендерится, но скрыт при загрузке */}
      <div style={{ visibility: isAllLoaded ? 'visible' : 'hidden' }}>
        <TasksHeader />
        <div className={styles.container__contentContainer}>
          <div className={styles.container__content}>
            <BalanceTop />
            <div className={styles.leaderboardContainer}>
              <DailyTasks onLoadingChange={handleDailyTasksLoadingChange} />
              <PartnerTasks onLoadingChange={handlePartnerTasksLoadingChange} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TasksPage;
